export const Services = [
	{
		id: 1,
		title: "",
	},
];

export const ContactSubjects = [
	{
		id: 1,
		title: "Project Pricing",
	},
	{
		id: 2,
		title: "Developer Outsourcing",
	},
	{
		id: 3,
		title: "IT Recruitment",
	},
	{
		id: 4,
		title: "Other",
	},
];
